import type { Role } from '@/shared/enums';

export type JwtPayload = {
  sub: string;
  email: string;
  role: Role;
  display_name: string | null;
  avatar_url: string | null;
  exp: number; // seconds
  iat: number;
};

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}
